import config from '../../../config/api';

export interface SendDashboardEmailResponse {
  request_id: string;
  message: string;
}

const buildHeaders = (userId: string, token: string | null): HeadersInit => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'X-User-ID': userId,
  };
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
};

const handleResponse = async <T>(response: Response, label: string): Promise<T> => {
  const text = await response.text();
  if (!response.ok) {
    let message = `${label} failed with HTTP ${response.status}`;
    if (text) {
      try {
        const parsed = JSON.parse(text) as { detail?: string };
        message = typeof parsed.detail === 'string' ? parsed.detail : text;
      } catch {
        message = text;
      }
    }
    const error = new Error(message) as Error & { status?: number };
    error.status = response.status;
    throw error;
  }
  if (!text) return {} as T;
  return JSON.parse(text) as T;
};

export const sendDashboardEmail = async (
  userId: string,
  token: string | null,
  dashboardId: string,
  subject: string,
  to: string,
): Promise<SendDashboardEmailResponse> => {
  const url = `${config.apiUrl}/market-monitor/dashboards/${encodeURIComponent(dashboardId)}/email`;
  const response = await fetch(url, {
    method: 'POST',
    headers: buildHeaders(userId, token),
    body: JSON.stringify({ subject, to }),
  });
  return handleResponse<SendDashboardEmailResponse>(response, 'Send dashboard email');
};
